<template>
  <v-card style="height: 100%; max-height: 100%; overflow-y: auto" class="ma-0 pa-0" flat>
    <v-row class="ma-0 pa-0" style="width: 100%" align="center">
      <v-col cols="12" v-if="!graph_visible">
        <v-skeleton-loader
          light
          :style="{
            height: screenHeight + 'px',
          }"
          type="image,image,image,image"
        ></v-skeleton-loader>
      </v-col>
      <v-col v-if="graph_visible" class="ma-0 pa-0">
        <v-row class="ma-0 pa-0" style="height: 100%">
          <v-col cols="12">
            <div :style="{ height: screenHeight + 'px' }">
              <v-chart
                class="chartComponent"
                :option="graph_options"
                :ref="chart_ref"
                :id="chart_id"
                autoresize
              ></v-chart>
            </div>
          </v-col>
          <!-- </v-col> -->
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import VChart, { THEME_KEY } from "vue-echarts";
import "echarts";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
("echarts/charts");
import { TitleComponent, TooltipComponent, LegendComponent } from "echarts/components";

use([CanvasRenderer, TitleComponent, TooltipComponent, LegendComponent]);

export default {
  name: "NetworkGraph",
  props: ["dataset", "chart_ref", "chart_id"],
  components: {
    VChart,
  },
  provide: {
    [THEME_KEY]: "light",
  },
  methods: {
    reload_graph: function () {
      this.graph_visible = false;
      setTimeout(() => (this.graph_visible = true), 10);
    },
  },

  data: () => ({
    graph_visible: false,
    graph_data: null,
    screenHeight: window.innerHeight * 0.5,
  }),
  mounted() {
    this.graph_data = this.dataset;
    if (this.dataset != null) {
      this.reload_graph();
    }
  },
  watch: {
    dataset: {
      immediate: false,
      handler: function () {
        this.graph_data = this.dataset;
        if (this.dataset != null) {
          this.reload_graph();
        }
      },
      deep: true,
    },
  },
  computed: {
    graph_options: function () {
      let graph = {... this.graph_data}
      let option = {
        title: {},
        tooltip: {},
        color: [
          "#4E79A7", // Blue
          "#59A14F", // Green
          "#B07AA1", // Purple
          "#76B7B2", // Teal
          "#FF9DA7", // Pink
          "#9C755F", // Brown
          "#BAB0AC",  // Gray
          "#F28E2B", // Orange
          "#E15759", // Red
        ],
        legend: [
          {
            // selectedMode: 'single',
            data: graph.categories.map(function (a) {
              return a.name;
            }),
            textStyle: {
              color: '#000000'
              // bold: true
            },
            type: 'scroll'
          }
        ],
        series: [
          {
            name: '',
            type: 'graph',
            layout: 'force',
            data: graph.nodes,
            links: graph.links,
            categories: graph.categories,
            roam: true,
            label: {
              position: 'right'
            },
            force: {
              repulsion: 100
            }
          }
        ]
      };
      return option;
    },
  },
};
</script>

<style scoped>

.chartComponent {
  height: 100%;
  width: 100%;
}

</style>